module.exports = __webpack_public_path__ + "static/media/flagHazardous.ed9b54e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Flags/flagHazardous.svg
// module id = 895
// module chunks = 0